var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUpload = function SvgUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#828282",
    d: "M16.8 30.384 24 24l7.2 6.384h-4.8V43.2h-1.8a3 3 0 0 1-3-3v-9.816z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#828282",
    d: "M24 9.6c5.56 0 10.413 3.63 12.103 8.867a9.215 9.215 0 0 1 7.097 9.028c0 5.295-4.255 9.305-9.159 9.305H28.8v-2h5.241c3.813 0 7.16-3.128 7.16-7.305a7.215 7.215 0 0 0-5.554-7.08l-1.1-.258-.347-1.076c-1.43-4.43-5.526-7.48-10.2-7.481-3.751 0-7.113 1.961-9.046 5.019l-.454.718-.83.172c-3.83.793-6.87 4.226-6.87 8.554 0 4.966 3.993 8.737 8.593 8.737H19.2v2h-3.807C9.7 36.8 4.8 32.146 4.8 26.063c0-5.303 3.733-9.534 8.464-10.513C15.548 11.936 19.535 9.6 24 9.6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#828282",
    d: "M26.4 36.8c0 4.8 1.6 6.4 1.6 6.4h-1.6z"
  })));
};
export default SvgUpload;